var _a;
import React, { useMemo } from "react";
import { FormattedMessage } from "react-intl";
import styles from "./InfoBox.module.css";
export var InfoBoxTypeEnum;
(function (InfoBoxTypeEnum) {
    InfoBoxTypeEnum["INFO"] = "info";
    InfoBoxTypeEnum["WARNING"] = "warning";
})(InfoBoxTypeEnum || (InfoBoxTypeEnum = {}));
var VARIANT_CONFIG = (_a = {},
    _a[InfoBoxTypeEnum.INFO] = {
        icon: "ℹ",
        containerClass: styles.containerInfo,
    },
    _a[InfoBoxTypeEnum.WARNING] = {
        icon: "⚠️",
        containerClass: styles.containerWarning,
    },
    _a);
export var InfoBox = function (_a) {
    var titleId = _a.titleId, _b = _a.type, type = _b === void 0 ? InfoBoxTypeEnum.INFO : _b, customIcon = _a.customIcon, children = _a.children;
    var variant = useMemo(function () { return VARIANT_CONFIG[type]; }, [type]);
    return (React.createElement("div", { className: "".concat(styles.container, " ").concat(variant.containerClass) },
        React.createElement("div", { className: styles.content },
            React.createElement("span", { className: styles.icon }, customIcon !== null && customIcon !== void 0 ? customIcon : variant.icon),
            React.createElement("div", { className: styles.textContainer },
                titleId && (React.createElement("strong", { className: styles.title },
                    React.createElement(FormattedMessage, { id: titleId }))),
                children))));
};
